var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00017 1.8244C4.48926 1.8244 1.64307 4.67059 1.64307 8.1815C1.64307 11.6925 4.48926 14.5387 8.00017 14.5387C11.5112 14.5387 14.3574 11.6925 14.3574 8.1815C14.3574 4.67059 11.5112 1.8244 8.00017 1.8244ZM0.643066 8.1815C0.643066 4.11831 3.93698 0.824402 8.00017 0.824402C12.0635 0.824402 15.3574 4.11831 15.3574 8.1815C15.3574 12.2448 12.0635 15.5387 8.00017 15.5387C3.93698 15.5387 0.643066 12.2448 0.643066 8.1815ZM7.99997 7.68158C8.27617 7.68158 8.49997 7.90544 8.49997 8.1816V11.6102C8.49997 11.8863 8.27617 12.1102 7.99997 12.1102C7.72386 12.1102 7.50001 11.8863 7.50001 11.6102V8.1816C7.50001 7.90544 7.72386 7.68158 7.99997 7.68158ZM8.85737 5.61013C8.85737 6.08352 8.47357 6.46728 8.00017 6.46728C7.52683 6.46728 7.14307 6.08352 7.14307 5.61013C7.14307 5.13675 7.52683 4.75299 8.00017 4.75299C8.47357 4.75299 8.85737 5.13675 8.85737 5.61013Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.4b6e9b5db491d46f7beeedcad9fec018.svg";
export { ForwardRef as ReactComponent };